import React from 'react';
import InboxDashboard from '../../components/Inbox/InboxDashboard/InboxDashboard';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const InboxContainer = () => {
    return (
        <WithNavigation
        title="Inbox"
        hide={true}
        border
         top={(
           <InboxDashboard
           image={(
             <img
               alt="No properties yet"
               src="/assets/empty/service-requests.svg"
             />
           )}
         />
         )}
        />
    )
}

export default InboxContainer;
